import React, { CSSProperties } from "react";
import { Button, ButtonProps, Tooltip } from "@material-ui/core";
import styled from "styled-components";

const StyledButton = styled(Button)<ButtonProps>`
  & > span > div > svg {
    transition: margin-left 0.2s ease-out;
  }

  &:hover {
    box-shadow: ${({ disabled }) =>
      disabled ? "unset" : "inset 0 0 6px #00000080"};
    & > span > div > svg {
      margin-left: 15px !important;
    }
  }
`;

function RoundButton({
  customColor,
  customBackgroundColor,
  disabledLabel,
  style,
  ...rest
}: ButtonProps & IButtonProps) {
  const baseStyle: CSSProperties = {
    borderRadius: "5px",
    fontWeight: 400,
    border: "none",
    textTransform: "none",
    fontSize: "1.2em",
    backgroundColor: rest.disabled
      ? undefined
      : customBackgroundColor
      ? customBackgroundColor
      : "#e75f2d",
    pointerEvents: "auto",
    cursor: rest.disabled ? "not-allowed" : "pointer",
  };

  const normalizedBackgroundColor =
    typeof style?.backgroundColor === "string"
      ? style.backgroundColor.replace(/\s+/g, "").toLowerCase()
      : typeof baseStyle.backgroundColor === "string"
      ? baseStyle.backgroundColor.replace(/\s+/g, "").toLowerCase()
      : undefined;
  const hasBackgroundColor =
    !!normalizedBackgroundColor &&
    normalizedBackgroundColor !== "transparent" &&
    normalizedBackgroundColor !== "rgba(0,0,0,0)";

  const colorStyle: CSSProperties = customColor
    ? { color: customColor, borderColor: customColor }
    : { color: hasBackgroundColor ? "white" : "black" };

  const mergedStyle: CSSProperties = {
    ...baseStyle,
    ...colorStyle,
    ...style,
  };

  const button = (
    <StyledButton variant={"outlined"} {...rest} style={mergedStyle} />
  );

  if (rest.disabled && disabledLabel) {
    return (
      <Tooltip enterDelay={500} placement={"top"} title={disabledLabel}>
        {button}
      </Tooltip>
    );
  }

  return button;
}

export default RoundButton;
export interface IButtonProps {
  customColor?: string;
  customBackgroundColor?: string;
  disabledLabel?: string;
}
